import getScriptBaseUrl from 'owa-session-store/lib/actions/getScriptBaseUrl';
import { getSessionId } from 'owa-analytics/lib/LazyAnalytics';

export default function generateDiagnosticReport(): string {
    return (
        // This indenting is done to preserve the formatting of the string without having to concatenate a new string on each line
        `UserAgent: ${window.navigator.userAgent}
Script source: ${getScriptBaseUrl()}
Session Id: ${getSessionId()}
Client ID: ${window.bootstrapDiagnostics.clientId}
Client Server: ${window.bootstrapDiagnostics.server}
BE Server: ${window.genericDiagnostics && window.genericDiagnostics.be}`
    );
}
